import { Text } from 'components/Typography';
import * as S from '../style';
import { ReactComponent as IcReloadCircle } from 'constants/icon/ic_reload_circle.svg';
import { Stack } from 'components/Stack';
import moment from 'moment';

export default function DeliveryExpectTimeComponent({
  ...props
}: {
  eta: string;
  deliveryInfoRefetch: any;
  progressStatus: { [key: string]: { step: string; status: string; date: string } };
  now: string;
}) {
  return (
    <S.ExpectTimeContainer>
      {/* 도착 예상 시간 */}
      <S.ExpectTimeBox>
        <Stack direction="row" justify="center" spacing={8}>
          <Text styleName={'subheadline2'} color="#565B69">
            {props?.now === 'completed' ? '완료 시간' : '도착 예상 시간'}
          </Text>
          <S.ProgressStatusIcon color={props?.now === 'completed' ? '#13C097' : '#ffa217'}>
            {props?.now === 'completed' ? '처리완료' : '처리중'}
          </S.ProgressStatusIcon>
        </Stack>
        <Stack direction="row" justify="center" spacing={12}>
          <Text
            styleName={'headline1'}
            sx={{ fontSize: '1.4rem' }}
            color={props?.now === 'completed' ? '#1C48CD' : '#25282F'}
          >
            {props?.now === 'completed'
              ? moment(props?.progressStatus['completed']?.date, 'YYYYMMDDHHmmss')
                  .format('YYYY년 MM월 DD일 a hh:mm')
                  .replace('am', '오전')
                  .replace('pm', '오후')
              : moment(props?.eta, 'YYYYMMDDHHmmss').subtract(120, 'minutes').format('HH:mm') +
                ' ~ ' +
                moment(props?.eta, 'YYYYMMDDHHmmss').add(120, 'minutes').format('HH:mm')}
          </Text>
          {!(props?.now === 'completed') && (
            <S.IconButton
              onClick={() => {
                props?.deliveryInfoRefetch();
              }}
            >
              <IcReloadCircle />
            </S.IconButton>
          )}
        </Stack>
      </S.ExpectTimeBox>
    </S.ExpectTimeContainer>
  );
}
